import { render, staticRenderFns } from "./MyProceedsChartReport.vue?vue&type=template&id=3b41792b&scoped=true&"
import script from "./MyProceedsChartReport.vue?vue&type=script&lang=js&"
export * from "./MyProceedsChartReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b41792b",
  null
  
)

export default component.exports